export default __webpack_public_path__ + "static/media/question-circle.6892f055.svg";